import React from 'react';
import classnames from 'classnames';
import {cssBEM} from './index.jsx';
import {FormattedHTMLMessage, useIntl} from 'react-intl';

const Card = ({ card, disabled, isActive, onAddClicked, onEditClicked, onRemoveClicked, renderCardBodyFn }) => {

  const intl = useIntl();
  const messagesLabel = intl.formatMessage({id: card.labelMessageId});
  const stripTags = /(<([^>]+)>)/ig;
  const cardLabel = messagesLabel.replace(stripTags , '');
  const classes = classnames(
    `${cssBEM}__card`,
    {
      [`${cssBEM}__card--active`] : isActive,
      [`${cssBEM}__card--inactive`] : !isActive
    }
  );

  const addBtn = <button type='button' className={`${cssBEM}__btn ${cssBEM}__btn--addCard`} onClick={() => onAddClicked(card)} role='button' aria-label={`Add ${cardLabel}`}>
    <FormattedHTMLMessage id='cardBuilder.addCard' />
  </button>;

  const editBtn = <button type='button' className={`${cssBEM}__btn ${cssBEM}__btn--editCard`} onClick={() => onEditClicked(card)} role='button' aria-label={`Edit ${cardLabel}`}>
    <FormattedHTMLMessage id='cardBuilder.editCard' />
  </button>;

  const removeBtn = <button type='button' className={`${cssBEM}__btn ${cssBEM}__btn--removeCard`} onClick={() => onRemoveClicked(card)} role='button' aria-label={`Remove ${cardLabel}`}>
    <FormattedHTMLMessage id='cardBuilder.removeCard' />
  </button>;

  const renderCardBody = () => {
    let render = null;
    if(renderCardBodyFn){
      const cardParams = {
        card,
        isActive,
        onAddClicked,
        onEditClicked,
        onRemoveClicked
      };
      render = <div className={`${cssBEM}__card-content-body`}>{ renderCardBodyFn(cardParams) }</div>;
    }
    return render;
  };

  return (
    <div className={classes} id={`cardBuilderCard-${card.id}`}>
      <div className={`${cssBEM}__card-actions`}>
        { !isActive && !disabled ? addBtn : null }
        { isActive  && !disabled ? editBtn : null }
        { isActive ? removeBtn : null }
      </div>

      <section className={`${cssBEM}__card-content`}>
        <FormattedHTMLMessage id={card.labelMessageId} tagName='h3' />
        { renderCardBody() }
      </section>
    </div>
  );
};

export default Card;
